var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dashboard-container"},[_c('total-stat',{attrs:{"stat":_vm.totalStat}}),_c('div',{staticClass:"d-content"},[_c('news-list',{attrs:{"newsList":_vm.newsList}}),_c('others-stat',{attrs:{"stat":_vm.todayStat,"bugCount":_vm.bugCount}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }